/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import get from 'lodash/get';
import merge from 'lodash/merge';

import {
  GET_PLATFORM_CONNECTION_INFO,
  GET_PLATFORM_CONNECTION_INFO_FAILURE,
  GET_PLATFORM_CONNECTION_INFO_SUCCESS,
} from 'connectActionCreators';

export const connectReducer = (state = { data: {}, fetchingData: false }, action) => {
  switch (action.type) {
    case GET_PLATFORM_CONNECTION_INFO_SUCCESS:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: null,
        data: action.payload,
      };
    case GET_PLATFORM_CONNECTION_INFO:
      return {
        ...state,
        fetchingData: action.type,
        fetchDataError: null,
      };
    case GET_PLATFORM_CONNECTION_INFO_FAILURE:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: action.payload,
      };
    default:
      return state;
  }
};

// selectors
export const getPlatformConnectionInfo = state =>
  merge(
    get(state, 'currentUser.userData.iotpCredentials'),
    get(state, 'platformConnectionInfo.data.iotp')
  );

export const isFetchingPlatformConnectionInfo = state =>
  get(state, 'platformConnectionInfo.fetchingData') !== false;
